export function isLocalOrDevFlowStudioHost(hostname: string = globalThis?.location?.hostname || ''): boolean {
  const host = (hostname || '').toLowerCase();
  return host === 'dev.flowstudio.app'
    || host === 'localhost'
    || host === '127.0.0.1'
    || host === '[::1]'
    || host.endsWith('.localhost');
}

export function adminTrace(message: string, ...optionalParams: any[]): void {
  if (!isLocalOrDevFlowStudioHost()) {
    return;
  }
  console.log(message, ...optionalParams);
}
